// JsFromRoutes CacheKey d307a62e7ef00a3e2e2e979bbbfd7fbb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  update: /* #__PURE__ */ definePathHelper('patch', '/:org_nano_id/first_use'),
}
